import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { Checkbox, FormControlLabel } from "@mui/material";

function FileDataAccessRestrictedCheckbox({ control }) {
  return (
    <Controller
      name="accessRestricted"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={<Checkbox {...field} checked={field.value} />}
          label="Zugriffsbeschränkt"
        />
      )}
    />
  );
}

FileDataAccessRestrictedCheckbox.propTypes = {
  control: PropTypes.object,
};

export default FileDataAccessRestrictedCheckbox;
